import { useState, useMemo, useContext } from 'react';
import { StaticContext } from '@sm/webassets';
import { getDataCenterIdFromCurrentUrl, getDataCenterById } from '@sm/locale';

import useFeatureSet from './useFeatureSet';
import { FeatureSet, SummaryDisplayFeatureList } from '~shared/types/pricing/features';
import SummaryFeatureTransformers from '~pricing/transformers/summary';
import { Packages } from '~shared/constants/pricing';

export default function useSummaryDisplayFeatures(
  features: FeatureSet,
  packageName: Packages
): SummaryDisplayFeatureList {
  const {
    environment: { slLanguageLocale, countryCode },
    hostname,
    url,
  } = useContext(StaticContext);

  const dataCenter = getDataCenterById(getDataCenterIdFromCurrentUrl(`${hostname}${url}`));

  const featureTransformer = SummaryFeatureTransformers[packageName];
  const featureSetMap = useFeatureSet(features);
  const [displayFeatures, setDisplayFeatures] = useState<SummaryDisplayFeatureList>([]);

  useMemo(() => {
    if (featureTransformer) {
      const featureSetData = featureTransformer(featureSetMap, {
        locale: slLanguageLocale,
        countryCode,
        dataCenter: dataCenter?.regionCode,
        packageName,
      });
      setDisplayFeatures(featureSetData);
    }
  }, [featureSetMap, featureTransformer, slLanguageLocale, countryCode, dataCenter, packageName]);

  return displayFeatures;
}
